import React from "react";

export type SortProps = {
  /**
   * Width of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  width?: number;
  /**
   * Height of the logo
   * if you overrides width + height, 'size' props will be ignored
   */
  height?: number;
  /**
   * Choose between them value
   * @default black
   */
  color?: string;
  /**
   * The size of the logo
   * small: 122*46 | medium: 155*60 | large: 217*83
   * @default medium
   */
  size?: "small" | "medium" | "large";
};

const sizes = {
  small: {
    width: 34,
    height: 34,
  },
  medium: {
    width: 34,
    height: 34,
  },
  large: {
    width: 34,
    height: 34,
  },
};

export const Sort: JSX.Element & any = React.forwardRef<
  SVGSVGElement,
  SortProps
>((props, ref) => {
  const { size = "medium", width, height, color = "#77757F" } = props;
  const svgSize = width && height ? { width, height } : sizes[size];
  return (
    <svg
      ref={ref}
      width={svgSize.width}
      height={svgSize.height}
      viewBox="0 0 15 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15 3.5H0V2.5H15V3.5ZM12 8.5H3V7.5H12V8.5ZM10 13.5H5V12.5H10V13.5Z"
        fill={color}
      />
    </svg>
  );
});

Sort.displayName = "Sort";
